import { render, staticRenderFns } from "./MatrixUserInfoModal.vue?vue&type=template&id=d784366e&scoped=true&"
import script from "./MatrixUserInfoModal.vue?vue&type=script&lang=js&"
export * from "./MatrixUserInfoModal.vue?vue&type=script&lang=js&"
import style0 from "./MatrixUserInfoModal.vue?vue&type=style&index=0&id=d784366e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d784366e",
  null
  
)

export default component.exports